/**
* @file 账号管理
* */
<template>
  <div id="member">
    <!-- 账号详情抽屉 -->
    <el-drawer :visible.sync="drawerVisible" :title="'账号详情 - ' + (drawerAdmin.name || '')" size="680px" @close="drawerClose">
      <div class="drawer-content" v-if="drawerAdmin.id">
        <div class="drawer-header">
          <div class="drawer-avatar">
          <img v-if="drawerAdmin.avatar" :src="mixinQiniuImg(drawerAdmin.avatar)" class="drawer-avatar-img" @error="drawerAdmin.avatar = null" />
          <span v-else>{{ (drawerAdmin.name || '?').charAt(0) }}</span>
          <div class="drawer-avatar-upload" @click="triggerAvatarUpload(drawerAdmin)" title="点击更换头像">
            <i class="el-icon-camera"></i>
          </div>
          <input ref="avatarInput" type="file" accept="image/jpeg,image/png,image/gif" style="display:none" @change="handleAvatarChange" />
        </div>
          <div class="drawer-header-info">
            <div class="drawer-name">{{ drawerAdmin.name }}</div>
            <div class="drawer-tags">
              <el-tag size="mini" :type="drawerAdmin.gender === 1 ? 'primary' : drawerAdmin.gender === 2 ? 'danger' : 'info'" style="margin-right:6px">
                {{ drawerAdmin.gender === 1 ? '男' : drawerAdmin.gender === 2 ? '女' : '未知' }}
              </el-tag>
              <el-tag size="mini" type="info" style="margin-right:6px">{{ drawerAdmin.roleName || '-' }}</el-tag>
              <el-tag size="mini" :type="drawerAdmin.status === 1 ? 'success' : 'danger'">{{ drawerAdmin.status === 1 ? '启用' : '禁用' }}</el-tag>
            </div>
          </div>
        </div>

        <el-tabs v-model="drawerTab" @tab-click="handleDrawerTabClick" class="drawer-tabs">
          <el-tab-pane label="基本信息" name="info">
            <el-descriptions :column="1" border size="small" class="drawer-desc">
              <el-descriptions-item label="手机号">{{ drawerAdmin.phone }}</el-descriptions-item>
              <el-descriptions-item label="姓名">{{ drawerAdmin.name }}</el-descriptions-item>
              <el-descriptions-item label="性别">
                <el-tag size="mini" :type="drawerAdmin.gender === 1 ? 'primary' : drawerAdmin.gender === 2 ? 'danger' : 'info'">
                  {{ drawerAdmin.gender === 1 ? '男' : drawerAdmin.gender === 2 ? '女' : '未知' }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="角色权限">{{ drawerAdmin.roleName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="账号状态">
                <el-tag size="mini" :type="drawerAdmin.status === 1 ? 'success' : 'danger'">{{ drawerAdmin.status === 1 ? '启用' : '禁用' }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="登录次数">
                <span style="color:#409eff;font-weight:600">{{ drawerAdmin.loginCount || 0 }}</span> 次
              </el-descriptions-item>
              <el-descriptions-item label="最后登录时间">{{ drawerAdmin.lastLoginTime | filterTime }}</el-descriptions-item>
              <el-descriptions-item label="最后登录IP">{{ drawerAdmin.lastLoginIp || '-' }}</el-descriptions-item>
              <el-descriptions-item label="最后登录位置">{{ drawerAdmin.lastLoginAddress || '-' }}</el-descriptions-item>
              <el-descriptions-item label="最后登录设备">{{ drawerAdmin.lastLoginDevice || '-' }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ drawerAdmin.created | filterTime }}</el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="登录记录" name="logs">
            <el-table :data="drawerLogs" v-loading="drawerLogsLoading" size="small" stripe border style="width:100%">
              <el-table-column label="登录时间" min-width="150">
                <template slot-scope="{ row }">{{ row.created | filterTime }}</template>
              </el-table-column>
              <el-table-column label="IP" prop="ip" min-width="120"></el-table-column>
              <el-table-column label="位置" min-width="180">
                <template slot-scope="{ row }">{{ row.ipAddress || '-' }}</template>
              </el-table-column>
              <el-table-column label="浏览器/系统" min-width="200">
                <template slot-scope="{ row }">
                  <div>{{ row.browser || '-' }}</div>
                  <div style="color:#999;font-size:12px">{{ row.os }}</div>
                </template>
              </el-table-column>
              <el-table-column label="网络" min-width="120">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.networkType" size="mini" type="info" style="margin-right:4px">{{ row.networkType }}</el-tag>
                  <el-tag v-if="row.deviceType" size="mini">{{ row.deviceType }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="运营商" prop="isp" min-width="100"></el-table-column>
              <el-table-column label="代理" min-width="70">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.isProxy" type="warning" size="mini">代理</el-tag>
                  <span v-else style="color:#67c23a;font-size:12px">正常</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="float:right;margin-top:10px"
              @current-change="handleDrawerLogsPage"
              :current-page="drawerLogsPage" :page-size="20"
              layout="total, prev, pager, next" :total="drawerLogsTotal">
            </el-pagination>
          </el-tab-pane>

          <el-tab-pane label="绑定设备" name="devices">
            <div class="device-tip">
              <i class="el-icon-info" style="color:#409eff;margin-right:6px"></i>
              登录过的设备将自动记录。可解绑不再使用的设备。
            </div>
            <el-table :data="drawerDevices" v-loading="drawerDevicesLoading" size="small" stripe border style="width:100%">
              <el-table-column label="设备指纹" min-width="100">
                <template slot-scope="{ row }"><span style="font-family:monospace;font-size:12px;color:#909399">{{ row.deviceFingerprintMasked || '-' }}</span></template>
              </el-table-column>
              <el-table-column label="浏览器/系统" min-width="180">
                <template slot-scope="{ row }">
                  <div>{{ row.browser || '-' }}</div>
                  <div style="color:#999;font-size:12px">{{ row.os }}</div>
                </template>
              </el-table-column>
              <el-table-column label="设备" min-width="130">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.deviceType" size="mini" style="margin-right:4px">{{ row.deviceType }}</el-tag>
                  <div style="color:#999;font-size:12px">{{ row.deviceBrand }} {{ row.deviceModel }}</div>
                </template>
              </el-table-column>
              <el-table-column label="首次绑定" min-width="140">
                <template slot-scope="{ row }">{{ row.firstLoginTime | filterTime }}</template>
              </el-table-column>
              <el-table-column label="最后使用" min-width="140">
                <template slot-scope="{ row }">{{ row.lastLoginTime | filterTime }}</template>
              </el-table-column>
              <el-table-column label="状态" min-width="75">
                <template slot-scope="{ row }">
                  <el-tag :type="row.isTrusted === 1 ? 'success' : 'info'" size="mini">{{ row.isTrusted === 1 ? '绑定' : '解绑' }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <!-- 编辑/创建模态框 -->
    <el-dialog :visible.sync="dialogVisible" :title="`${form.id ? '编辑' : '创建'}账号`" @close="dialogClose" width="30%" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select :disabled="form.id ? true : false" v-model="form.organizationId" filterable @change="roleList"
            v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{
            organizations && organizations[0] && organizations[0].name
          }}</span>
        </el-form-item>
        <!--1-总公司，2分公司-->
        <el-form-item label="登录手机号" prop="phone">
          <el-input v-model="form.phone" maxlength="11" placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" maxlength="10" placeholder="请输入真实姓名（10字以内）"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <div class="form-avatar-wrap">
            <div class="form-avatar-preview" @click="triggerFormAvatarUpload">
              <img v-if="form.avatar" :src="mixinQiniuImg(form.avatar)" class="form-avatar-img" />
              <div v-else class="form-avatar-placeholder">
                <i class="el-icon-plus"></i>
                <span>上传头像</span>
              </div>
            </div>
            <input ref="formAvatarInput" type="file" accept="image/jpeg,image/png,image/gif" style="display:none" @change="handleFormAvatarChange" />
            <span class="util-remark" style="margin-left:12px;line-height:1.5">支持JPG/PNG，建议正方形图片</span>
          </div>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form.gender" size="small">
            <el-radio :label="0">未知</el-radio>
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="密码" prop="password" :required="form.id ? false : true">
          <el-input v-model="form.password" type="password" autocomplete="new-password" maxlength="12"
            placeholder="请输入8～12位含数字+字母的密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="checkPassword" :required="form.id ? false : true">
          <el-input v-model="form.checkPassword" type="password" autocomplete="new-password" maxlength="12"></el-input>
        </el-form-item>
        <el-form-item label="角色权限" prop="roleId">
          <el-select :placeholder="roles && roles.length < 1
            ? '机构名称无可选角色权限'
            : '请选择'
            " v-model="form.roleId" filterable :disabled="roles && roles.length < 1">
            <el-option v-for="(item, index) in roles" :key="index" :label="item.roleName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="mixinUserInfo.platformType === 2" label="推广售票员" prop="type">
          <div class="flex-start">
            <el-switch v-model="form.type" :active-value="2" :inactive-value="1"></el-switch>
            <p style="margin-left: 20px" class="util-remark">
              如开启，则用户仅可登录移动售票端
            </p>
          </div>
        </el-form-item>

        <el-form-item v-if="mixinUserInfo.platformType === 2" label="推荐人" prop="referrerAdminId">
          <el-select v-model="form.referrerAdminId" filterable clearable>
            <el-option v-for="(item, i) in userList" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="mixinUserInfo.platformType === 3" label="用户类型" prop="type">
          <div>
            <div>
              <el-radio-group :disabled="!!form.id" v-model="form.type">
                <el-radio :label="1">普通用户</el-radio>
                <el-radio :label="3">渠道商用户</el-radio>
              </el-radio-group>
            </div>
            <p class="util-remark">渠道商用户仅可查看所负责渠道资源的数据</p>
          </div>
        </el-form-item>

        <el-form-item style="margin-top: 30px; text-align: right">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="创建账号" @addFn="addFn">
      <template slot="table-operation">
        <el-table-column label="操作" width="170" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="detailClick(row)">详情</el-button>
            <el-button type="text" @click="compileClick(row)">编辑</el-button>
            <el-button type="text" @click="enableClick(row)">{{ row.status == 1 ? '禁用' : '启用' }}</el-button>
            <el-button type="text" style="color: red;" @click="removeClick(row)">删除</el-button>
            <!-- <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click="compileClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i
                v-if="mixinUserInfo.id !== row.id"
                class="iconfont icon-delete"
                @click="removeClick(row)"
              ></i>
            </el-tooltip> -->
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <div v-if="item.prop === 'created'">{{ row.created | filterTime }}</div>
        <div v-else-if="item.prop === 'lastLoginTime'">
          <span>{{ row.lastLoginTime | filterTime }}</span>
        </div>
        <div v-else-if="item.prop === 'name'">
          <div class="member-name-cell">
            <div class="member-avatar-mini" v-if="row.avatar">
              <img :src="mixinQiniuImg(row.avatar)" class="avatar-img-mini" />
            </div>
            <div class="member-avatar-mini letter" v-else>{{ (row.name || '?').charAt(0) }}</div>
            <span>{{ row.name }}</span>
            <el-tag v-if="row.type === 2" effect="plain" size="mini">推广</el-tag>
            <el-tag v-if="row.type === 3" effect="plain" size="mini">渠道商</el-tag>
          </div>
        </div>
        <div v-else-if="item.prop === 'gender'">
          <el-tag size="mini" :type="row.gender === 1 ? 'primary' : row.gender === 2 ? 'danger' : 'info'">
            <span v-if="row.gender === 1">♂ 男</span>
            <span v-else-if="row.gender === 2">♀ 女</span>
            <span v-else>— 未知</span>
          </el-tag>
        </div>
        <div v-else-if="item.prop === 'roleName'">
          <el-tag v-if="row.roleName" size="small" type="warning" effect="plain">{{ row.roleName }}</el-tag>
          <span v-else style="color:#c0c4cc">-</span>
        </div>
        <div v-else-if="item.prop === 'loginCount'">
          <span style="color:#409eff;font-weight:600">{{ row.loginCount || 0 }}</span> 次
        </div>
        <div v-else-if="item.prop === 'lastLoginAddress'">
          <span style="font-size:12px;color:#606266">{{ row.lastLoginAddress || '-' }}</span>
        </div>
        <div v-else-if="item.prop === 'balance'">¥{{ row.balance || 0 }}</div>
        <div v-else-if="item.prop === 'status'">
          <el-tag :type="row.status === 1 ? 'success' : 'info'">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </div>
        <span v-else @dblclick="$utils.dblclickCopy">{{ row[item.prop] }}</span>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/admin",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [],
      },
      columns: [
        { prop: "phone", label: "登录手机号" },
        { prop: "name", label: "姓名" },
        { prop: "gender", label: "性别" },
        { prop: "roleName", label: "角色权限" },
        { prop: "loginCount", label: "登录次数" },
        { prop: "lastLoginTime", label: "最后登录时间" },
        { prop: "lastLoginAddress", label: "登录位置" },
        { prop: "referrerAdminName", label: "推荐人" },
        { prop: "balance", label: "钱包余额" },
        { prop: "status", label: "账号状态" },
        { prop: "created", label: "创建时间" },
      ],

      dialogVisible: false,
      roles: [],
      form: {
        organizationId: null,
        phone: null,
        name: null,
        password: null,
        checkPassword: null,
        roleId: null,
        type: 1,
        referrerAdminId: null,
        gender: 0,
        avatar: null,
      },
      avatarUploadTarget: null,
      drawerVisible: false,
      drawerAdmin: {},
      drawerTab: 'info',
      drawerLogs: [],
      drawerLogsTotal: 0,
      drawerLogsPage: 1,
      drawerLogsLoading: false,
      drawerDevices: [],
      drawerDevicesLoading: false,
      rules: {
        phone: [
          { required: true, message: "请输入登录手机号" },
          { pattern: /^1\d{10}$/, message: "请输入正确的手机号" },
        ],
        name: [{ required: true, message: "请输入用户名称" }],
        organizationId: [{ required: true, message: "请选择机构名称" }],

        checkPassword: [
          {
            validator: (rule, value, callback) => {
              // 编辑模式下，如果没有输入密码和确认密码，直接通过验证
              if (this.form.id && (!this.form.password || this.form.password === "") && (!value || value === "")) {
                callback();
                return;
              }
              
              // 创建模式下，确认密码必填
              if (!this.form.id && (!value || value === "")) {
                callback(new Error("请再次输入密码"));
                return;
              }
              
              // 两次密码必须一致
              if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        roleId: [{ required: true, message: "请选择角色权限" }],
        password: [
          {
            validator: (rule, value, callback) => {
              // 编辑模式下，如果没有输入密码，直接通过验证
              if (this.form.id && (!value || value === "")) {
                callback();
                return;
              }
              
              // 创建模式下，密码必填
              if (!this.form.id && (!value || value === "")) {
                callback(new Error("请输入密码"));
                return;
              }

              // 密码格式验证：8-12位且同时包含数字和字母
              let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/;
              if (!reg.test(value)) {
                callback(new Error("请输入8～12位且同时包含数字和字母的密码"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
      loading: false,
      userList: [],
    };
  },
  async created() {
    if (this.mixinUserInfo.platformType !== 2) {
      this.customOptions.search = [];
      this.columns = this.columns.filter(
        (item) => item.prop !== "referrerAdminName" && item.prop !== "balance"
      );
    }
    this.setSearch()

    await this.mixinOrganizations();
    if (!this.id && this.mixinUserInfo?.organizationType === 2) {
      if (this.organizations?.[0]?.id) {
        this.organizationId = this.organizations[0].id;
        this.form.organizationId = this.organizations[0].id;
      }
      this.roleList();
    }
  },
  methods: {
    dialogClose() {
      this.$refs.form.resetFields();
      this.form.id = null;
      this.form.gender = 0;
      this.form.avatar = null;
      this.roles = [];
    },
    /* 触发抽屉头像文件选择 */
    triggerAvatarUpload(admin) {
      this.avatarUploadTarget = admin;
      this.$refs.avatarInput.click();
    },
    /* 触发表单头像文件选择 */
    triggerFormAvatarUpload() {
      this.$refs.formAvatarInput.click();
    },
    /* 抽屉头像上传处理 */
    async handleAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = '';
      await this.uploadAvatarFile(file, this.avatarUploadTarget, true);
    },
    /* 表单头像上传处理 */
    async handleFormAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      e.target.value = '';
      await this.uploadAvatarFile(file, this.form, false);
    },
    /* 七牛云头像上传核心方法 */
    async uploadAvatarFile(file, target, updateRemote) {
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning('图片不能超过5MB');
        return;
      }
      const token = await this.getQiniuTokenFn();
      if (!token) {
        this.$message.error('获取上传凭证失败');
        return;
      }
      const key = `admin/avatar/${Date.now()}_${Math.random().toString(36).slice(2)}.${file.name.split('.').pop()}`;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('token', token);
      formData.append('key', key);
      const loading = this.$loading({ text: '上传中...' });
      try {
        const res = await fetch('https://up-z1.qiniup.com', { method: 'POST', body: formData });
        const json = await res.json();
        if (json && json.key) {
          this.$set(target, 'avatar', json.key);
          if (updateRemote && target.id) {
            const { code } = await this.$axios.post(`/api/v1/manage/admin/${target.id}/avatar`, {
              avatar: json.key,
              appKey: this.mixinUserInfo?.appKey
            });
            if (code === 1) {
              this.$message.success('头像更新成功');
              this.$refs.customTable.listFn();
            }
          }
        } else {
          this.$message.error('上传失败');
        }
      } catch (err) {
        this.$message.error('上传出错: ' + err.message);
      } finally {
        loading.close();
      }
    },
    drawerClose() {
      this.drawerAdmin = {};
      this.drawerTab = 'info';
      this.drawerLogs = [];
      this.drawerDevices = [];
    },
    detailClick(row) {
      this.drawerAdmin = { ...row };
      this.drawerTab = 'info';
      this.drawerVisible = true;
    },
    async handleDrawerTabClick(tab) {
      if (tab.name === 'logs') {
        this.drawerLogsPage = 1;
        await this.fetchDrawerLogs();
      } else if (tab.name === 'devices') {
        await this.fetchDrawerDevices();
      }
    },
    async fetchDrawerLogs() {
      if (!this.drawerAdmin.id) return;
      this.drawerLogsLoading = true;
      const { code, data, total } = await this.$axios.get('/api/v1/manage/admin/login/logs', {
        adminId: this.drawerAdmin.id,
        appKey: this.mixinUserInfo.appKey,
        page: this.drawerLogsPage,
        size: 20
      });
      if (code === 1) {
        this.drawerLogs = data || [];
        this.drawerLogsTotal = total || 0;
      }
      this.drawerLogsLoading = false;
    },
    async fetchDrawerDevices() {
      if (!this.drawerAdmin.id) return;
      this.drawerDevicesLoading = true;
      const { code, data } = await this.$axios.get('/api/v1/manage/admin/bound/devices', {
        adminId: this.drawerAdmin.id,
        appKey: this.mixinUserInfo.appKey
      });
      if (code === 1) {
        this.drawerDevices = data || [];
      }
      this.drawerDevicesLoading = false;
    },
    handleDrawerLogsPage(page) {
      this.drawerLogsPage = page;
      this.fetchDrawerLogs();
    },
    setSearch() {
      switch (this.mixinUserInfo.platformType) {
        case 3:
          this.customOptions.search = [
            {
              type: "select",
              field: "type",
              name: "用户类型",
              value: null,
              option: [
                { label: "普通用户", value: 1 },
                { label: "渠道商用户", value: 3 },
              ],
            },
            {
              type: "input",
              field: "referrerAdminName",
              name: "推荐人名称",
              value: "",
            },
            {
              type: "input",
              field: "name",
              name: "用户名称",
              value: "",
            },
            {
              type: "input",
              field: "phone",
              name: "登录手机号",
              value: "",
            },
            {
              type: "select",
              field: "status",
              name: "账号状态",
              value: null,
              option: [
                { label: "启用", value: '1' },
                { label: "停用", value: '0' },
              ],
            },
          ];
          break;
        case 4:
          this.customOptions.search = [
            {
              type: "organizationId",
              field: "organizationId",
              name: "机构名称",
              value: "",
            },
            {
              type: "input",
              field: "name",
              name: "用户名称",
              value: "",
            },
            {
              type: "input",
              field: "phone",
              name: "登录手机号",
              value: "",
            },
            {
              type: "select",
              field: "status",
              name: "账号状态",
              value: null,
              option: [
              { label: "启用", value: '1' },
              { label: "停用", value: '0' },
              ],
            },
          ];
          break;
        default:
          this.customOptions.search = [
            {
              type: "select",
              field: "type",
              name: "用户类型",
              value: null,
              option: this.$const.USERTYPECODE,
            },
            {
              type: "input",
              field: "referrerAdminName",
              name: "推荐人名称",
              value: "",
            },
            {
              type: "input",
              field: "name",
              name: "用户名称",
              value: "",
            },
            {
              type: "input",
              field: "phone",
              name: "登录手机号",
              value: "",
            },
            {
              type: "select",
              field: "status",
              name: "账号状态",
              value: null,
              option: [
              { label: "启用", value: '1' },
              { label: "停用", value: '0' },
              ],
            },
          ];
          break;
      }
    },
    async getUserListFn(row) {
      let url = "/api/v1/manage/admin";
      let data = await this.$axios.get(url, { page: 1, size: 999, ...row });
      if (data && data.code === 1) {
        this.userList = data.data;
      }
    },

    /* 点击创建成员 */
    addFn() {
      this.dialogVisible = true;
      if (
        !this.id &&
        this.mixinUserInfo &&
        this.mixinUserInfo.organizationType === 2
      ) {
        if (
          this.organizations &&
          this.organizations[0] &&
          this.organizations[0].id
        ) {
          this.organizationId = this.organizations[0].id;
          this.form.organizationId = this.organizations[0].id;
        }
        this.roleList();
      }
    },
    /* 编辑角色 */
    compileClick(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = {
          ...row,
          password: null,
          checkPassword: null,
          gender: row.gender != null ? Number(row.gender) : 0,
        };
        this.roleList();
        this.getUserListFn({ organizationId: this.form.organizationId });
      });
    },
    enableClick(row) {
      let title = row.status == 0 ? "启用账号" : "停用账号";
      let content = row.status == 1 ? "是否确认停用该账号?" : "是否确认启用该账号?";
      this.$confirm(content, title, {}).then(async () => {
        let url = "/api/v1/manage/admin/updateStatus";
        let params = {
          id: row.id,
          status: row.status == 0 ? 1 : 0,
          appKey: this.mixinUserInfo?.appKey,
        };
        let {code} = await this.$axios.post(url, params);
        if (code === 1) {
          this.$message.success('操作成功');
          this.$refs.customTable.listFn();
        }
      });
    },
    /* 删除角色 */
    removeClick(row) {
      let url = '/api/v1/manage/admin'
      this.$confirm(
        "删除该成员后，该账户将无法登录，确认要删除吗?",
        "删除提示"
      ).then(async () => {
        let params = {
          id: row.id,
          appKey: this.mixinUserInfo?.appKey,
        };
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success("删除成功");
          this.$refs.customTable.listFn();
        }
      });
    },
    /* 接口调用-获取角色列表 */
    async roleList(val) {
      this.roles = [];
      if (val) {
        this.$set(this.form, "roleId", "");
      }
      if (!this.form.organizationId) {
        return;
      }
      let params = { organizationId: this.form.organizationId };
      let url = "/api/v1/manage/role";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.roles = data.data || [];
      }

      this.getUserListFn(params);
    },
    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /* 接口请求-提交角色 */
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/admin";
      let params = this.$utils.deepCopyFn(this.form);
      if (params.password) {
        params.password = this.$utils.sha256Fn(params.password);
      } else {
        delete params.password;
      }
      try {
        let data = await this.$axios[params.id ? "put" : "post"](url, params);
        if (data && data.code === 1) {
          this.$message.success("保存成功！");
          this.$refs.customTable.listFn();
          this.dialogVisible = false;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.member-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  .member-avatar-mini {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    .avatar-img-mini { width: 100%; height: 100%; object-fit: cover; }
    &.letter {
      background: linear-gradient(135deg, #409eff, #67c23a);
      display: flex; align-items: center; justify-content: center;
      color: #fff; font-size: 12px; font-weight: 600;
    }
  }
}

.form-avatar-wrap {
  display: flex;
  align-items: center;
  .form-avatar-preview {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    border: 1px dashed #dcdfe6;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;
    &:hover { border-color: #409eff; }
    .form-avatar-img { width: 100%; height: 100%; object-fit: cover; }
    .form-avatar-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #c0c4cc;
      font-size: 12px;
      i { font-size: 20px; margin-bottom: 4px; }
    }
  }
}

.drawer-content {
  padding: 16px 20px;

  .drawer-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;

    .drawer-avatar {
      position: relative;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: linear-gradient(135deg, #409eff, #67c23a);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 14px;
      overflow: hidden;
      cursor: pointer;
      .drawer-avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      span {
        color: #fff;
        font-size: 22px;
        font-weight: 600;
      }
      .drawer-avatar-upload {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 18px;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s;
        i { color: #fff; font-size: 12px; }
      }
      &:hover .drawer-avatar-upload { opacity: 1; }
    }

    .drawer-header-info {
      .drawer-name {
        font-size: 17px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 6px;
      }
      .drawer-tags {
        display: flex;
        align-items: center;
      }
    }
  }

  .drawer-tabs {
    .drawer-desc {
      margin-top: 8px;
    }
  }

  .device-tip {
    background: #f0f9ff;
    border: 1px solid #bae0ff;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #606266;
  }
}
</style>
